import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { splitter } from "../components/Listing";
export var generateQueryFromArray = function generateQueryFromArray(data) {
  var urlParams = new URLSearchParams();
  data.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (typeof value === "string" && value) {
      var prevData = urlParams.get(key);
      if (prevData) {
        urlParams.set(key, [prevData, value].join(splitter));
      } else {
        urlParams.set(key, value);
      }
    } else if (typeof value === "object" && value.length) {
      var _prevData = urlParams.get(key);
      if (_prevData) {
        urlParams.set(key, [_prevData, value.join(splitter)].join(splitter));
      } else {
        urlParams.set(key, value.join(splitter));
      }
    }
  });
  return urlParams.toString();
};